import authManage from "@/middlewares/manage/auth";
import selectOrganization from "@/middlewares/manage/select-organization";

export default {
  path: "account-summaries",
  component: () => import("@/views/Manage/ExportSummary/LayoutView.vue"),
  redirect: { name: "exportSummary" },
  children: [
    {
      path: "",
      name: "exportSummary",
      component: () => import("@/views/Manage/ExportSummary/ExportSummary.vue"),
      meta: {
        middleware: [selectOrganization, authManage],
      },
    },
  ],
};
